import {getEmailTemplateByIdUseCase} from '@/useCases/getEmailTemplateByIdUseCase'
import {useQuery} from '@tanstack/react-query'
import {useIntl} from 'react-intl'

interface Props {
  emailTemplateId?: string
}
export default function EmailTemplateDetails({emailTemplateId}: Props): React.JSX.Element {
  const {formatMessage} = useIntl()

  const {isFetching, data, error} = useQuery({
    queryKey: ['emailTemplateDetails', emailTemplateId],
    queryFn: ({signal}) => getEmailTemplateByIdUseCase({id: emailTemplateId ?? ''}, signal),
    enabled: !!emailTemplateId,
  })

  return (
    <div data-testid="email-template-details-container" className="-mt-1 overflow-auto px-1">
      <div className="mb-4 text-lg font-bold text-text-primary">
        {formatMessage({id: 'EMAIL_TEMPLATE_BUILDER.EMAIL_TEMPLATE_DETAILS_SECTION_TITLE'})}
      </div>
      {isFetching && (
        <p className="text-md my-16 items-center text-center" data-testid="email-template-details-loading">
          {formatMessage({id: 'EMAIL_TEMPLATE_DETAILS.EMAIL_TEMPLATE_DETAILS_LOADING_LABEL'})}
        </p>
      )}
      {!isFetching && error && (
        <p className="text-md my-16 items-center text-center" data-testid="email-template-details-error">
          {formatMessage({id: 'EMAIL_TEMPLATE_DETAILS.EMAIL_TEMPLATE_DETAILS_ERROR_LABEL'})}
        </p>
      )}
      {!isFetching && !error && (
        <div data-testid="email-template-details-content">
          <div className="border-b border-border-gray">
            <div className="pt-3 text-xs font-bold text-text-secondary">
              {formatMessage({id: 'EMAIL_TEMPLATE_BUILDER.EMAIL_TEMPLATE_NAME'})}
            </div>
            <div className="pb-3 pt-1 text-xs text-text-primary">{data?.content[0]?.template_name}</div>
          </div>
          <div className="border-b border-border-gray">
            <div className="pt-3 text-xs font-bold text-text-secondary">
              {formatMessage({id: 'EMAIL_TEMPLATE_BUILDER.EMAIL_TEMPLATE_CATEGORY'})}
            </div>
            <div className="pb-3 pt-1 text-xs text-text-primary">{data?.content[0]?.category}</div>
          </div>
          <div className="border-b border-border-gray">
            <div className="pt-3 text-xs font-bold text-text-secondary">
              {formatMessage({id: 'EMAIL_TEMPLATE_BUILDER.EMAIL_TEMPLATE_SUBJECT'})}
            </div>
            <div className="pb-3 pt-1 text-xs text-text-primary">{data?.content[0]?.subject}</div>
          </div>
          <div className="border-b border-border-gray">
            <div className="pt-3 text-xs font-bold text-text-secondary">
              {formatMessage({id: 'EMAIL_TEMPLATE_BUILDER.EMAIL_TEMPLATE_MESSAGE'})}
            </div>
            <div className="pb-3 pt-1 text-xs text-text-primary">{data?.content[0]?.body}</div>
          </div>
        </div>
      )}
    </div>
  )
}
